// 动态引入配置文件（缺点：浪费资源，暴露信息变多）
import Logger from '../assets/lib/logger'
import config from '../config/config'
import dev from '../config/dev'
import comm from '../assets/lib/comm'
import directives from '../assets/lib/directives'
import filters from '../assets/lib/filters'

export default {
  install: (Vue, options) => {
    let conf = config
    const hub = new Vue()
    // 初始化日志读取器，参数 0~3代表日志等级
    let logger = new Logger(3)
    if (process.env.NODE_ENV === 'development' || process.env.VUE_APP_CONFIG === 'uat') {
      conf = dev
      // 仅显示错误日志
      if (process.env.NODE_ENV === 'development') {
        logger = new Logger(0)
      }
    }
    // 初始化类对象
    Vue._config = conf
    Vue._hub = hub
    Vue._logger = logger

    // 定义继承属性
    Object.defineProperties(Vue.prototype, {
      $config: {
        get () {
          return conf
        }
      },
      $hub: {
        get () {
          return hub
        }
      },
      $logger: {
        get () {
          return logger
        }
      },
      $comm: {
        get () {
          return comm
        }
      }
    })

    // 挂载全局自定义指令
    Vue.use(directives)
    // 挂载全局过滤器
    Vue.use(filters)
    Vue._logger.debugger('初始化挂载配置成功')
  }
}
